import { MetadataStore } from 'breeze-client';

import { Bookmark } from './bookmark';
import { BusinessTransactionLock } from './business-transaction-lock';
import { DataRefresh } from './data-refresh';
import { Dataset } from './dataset';
import { DatasetAccess } from './dataset-access';
import { DraftBookmark } from './draft-bookmark';
import { ForgottenUser } from './forgotten-user';
import { GroupMembership } from './group-membership';
import { GroupPrincipal } from './group-principal';
import { OrganisationMembership } from './organisation-membership';
import { OrganisationPrincipal } from './organisation-principal';
import { OrganisationWorkspace } from './organisation-workspace';
import { OrganisationWorkspaceDeployment } from './organisation-workspace-deployment';
import { OrganisationWorkspaceInfo } from './organisation-workspace-info';
import { PbiDataset } from './pbi-dataset';
import { PbiDatasetRefresh } from './pbi-dataset-refresh';
import { PbiDeployment } from './pbi-deployment';
import { PbiOrganisationWorkspace } from './pbi-organisation-workspace';
import { PbiRefreshMessage } from './pbi-refresh-message';
import { PbiReport } from './pbi-report';
import { RefreshFailureIssueLink } from './refresh-failure-issue-link';
import { Report } from './report';
import { ReportAccess } from './report-access';
import { ReportActivityRecord } from './report-activity-record';
import { ReportActivityRecordInfo } from './report-activity-record-info';
import { ReportInfo } from './report-info';
import { ReportUserPreference } from './report-user-preference';
import { Role } from './role';
import { RoleAccess } from './role-access';
import { ServicePrincipal } from './service-principal';
import { ServicePrincipalRole } from './service-principal-role';
import { SQLCache } from './sql-cache';
import { TemplateWorkspace } from './template-workspace';
import { TemplateWorkspaceTargetSettings } from './template-workspace-target-settings';
import { UserPrincipal } from './user-principal';
import { UserReportFilter } from './user-report-filter';
import { UserReportWorkspaceFilter } from './user-report-workspace-filter';
import { UserRole } from './user-role';
import { WorkspaceDeploymentFailure } from './workspace-deployment-failure';

export class DsgRegistrationHelper {
  static register(metadataStore: MetadataStore) {
    metadataStore.registerEntityTypeCtor('PbiRefreshMessage', PbiRefreshMessage);
    metadataStore.registerEntityTypeCtor('BusinessTransactionLock', BusinessTransactionLock);
    metadataStore.registerEntityTypeCtor('Bookmark', Bookmark);
    metadataStore.registerEntityTypeCtor('DataRefresh', DataRefresh);
    metadataStore.registerEntityTypeCtor('Dataset', Dataset);
    metadataStore.registerEntityTypeCtor('DatasetAccess', DatasetAccess);
    metadataStore.registerEntityTypeCtor('DraftBookmark', DraftBookmark);
    metadataStore.registerEntityTypeCtor('ForgottenUser', ForgottenUser);
    metadataStore.registerEntityTypeCtor('GroupMembership', GroupMembership);
    metadataStore.registerEntityTypeCtor('GroupPrincipal', GroupPrincipal);
    metadataStore.registerEntityTypeCtor('OrganisationMembership', OrganisationMembership);
    metadataStore.registerEntityTypeCtor('OrganisationPrincipal', OrganisationPrincipal);
    metadataStore.registerEntityTypeCtor('OrganisationWorkspace', OrganisationWorkspace);
    metadataStore.registerEntityTypeCtor('OrganisationWorkspaceDeployment', OrganisationWorkspaceDeployment);
    metadataStore.registerEntityTypeCtor('OrganisationWorkspaceInfo', OrganisationWorkspaceInfo);
    metadataStore.registerEntityTypeCtor('PbiDataset', PbiDataset);
    metadataStore.registerEntityTypeCtor('PbiDatasetRefresh', PbiDatasetRefresh);
    metadataStore.registerEntityTypeCtor('PbiDeployment', PbiDeployment);
    metadataStore.registerEntityTypeCtor('PbiOrganisationWorkspace', PbiOrganisationWorkspace);
    metadataStore.registerEntityTypeCtor('PbiReport', PbiReport);
    metadataStore.registerEntityTypeCtor('RefreshFailureIssueLink', RefreshFailureIssueLink);
    metadataStore.registerEntityTypeCtor('Report', Report);
    metadataStore.registerEntityTypeCtor('ReportAccess', ReportAccess);
    metadataStore.registerEntityTypeCtor('ReportActivityRecord', ReportActivityRecord);
    metadataStore.registerEntityTypeCtor('ReportActivityRecordInfo', ReportActivityRecordInfo);
    metadataStore.registerEntityTypeCtor('ReportInfo', ReportInfo);
    metadataStore.registerEntityTypeCtor('ReportUserPreference', ReportUserPreference);
    metadataStore.registerEntityTypeCtor('Role', Role);
    metadataStore.registerEntityTypeCtor('RoleAccess', RoleAccess);
    metadataStore.registerEntityTypeCtor('SQLCache', SQLCache);
    metadataStore.registerEntityTypeCtor('ServicePrincipal', ServicePrincipal);
    metadataStore.registerEntityTypeCtor('ServicePrincipalRole', ServicePrincipalRole);
    metadataStore.registerEntityTypeCtor('TemplateWorkspace', TemplateWorkspace);
    metadataStore.registerEntityTypeCtor('TemplateWorkspaceTargetSettings', TemplateWorkspaceTargetSettings);
    metadataStore.registerEntityTypeCtor('UserPrincipal', UserPrincipal);
    metadataStore.registerEntityTypeCtor('UserReportFilter', UserReportFilter);
    metadataStore.registerEntityTypeCtor('UserReportWorkspaceFilter', UserReportWorkspaceFilter);
    metadataStore.registerEntityTypeCtor('UserRole', UserRole);
    metadataStore.registerEntityTypeCtor('WorkspaceDeploymentFailure', WorkspaceDeploymentFailure);
  }
}
